import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static identifier = "modal-message"
  static values = { id: Number }

  confirm(event) {
    // Prevent the default form submission to handle it manually
    event.preventDefault()
    
    // Close the dialog if it's a dialog element
    if (this.element instanceof HTMLDialogElement) {
      this.element.close()
      this.element.classList.remove("modal-open")
    }
    
    // Submit the form
    event.target.form.submit()
    
    // Remove the modal after a short delay for better UX
    setTimeout(() => {
      this.element.remove()
    }, 100)
  }

  connect() {
    // Ensure the dialog is shown if it's a dialog element
    if (this.element instanceof HTMLDialogElement && !this.element.open) {
      this.element.showModal()
      this.element.classList.add("modal-open")
    }
    
    // Prevent background scrolling when modal is open
    // Only set if not already set to handle multiple modals
    if (!document.body.style.overflow || document.body.style.overflow === '') {
      document.body.style.overflow = 'hidden'
    }
  }

  disconnect() {
    // Only restore scrolling if there are no other modals open
    const otherModals = document.querySelectorAll('dialog.modal-open, dialog.modal[open]')
    if (otherModals.length === 0) {
      document.body.style.overflow = ''
    }
  }
}
